module.exports = __webpack_public_path__ + "img/18.34eba5b8.jpg";